<h2 class="mbottom-12">
  Verify your academic email address <br />
  to finish your registration
</h2>
<yat-verify-email-ui id="3877aa9e-5f8c-4a25-94a7-a6be7b6f28d1"
  scenario="academic"
  [pollingConfiguration]="pollingConfiguration"
  [email]="email$ | async"
  (resendEmail)="resendVerification()"
  (cancel)="cancelSignUp()">
</yat-verify-email-ui>
